import type { WeekSchedule } from "./OpenningTimes";
import { useTranslation } from "react-i18next";

const formatTime = (time: string) => {
  const [hours, minutes] = time.split(":");
  return `${hours}:${minutes}`;
};

export const OpeningTimesSummary: React.FC<{ schedule: WeekSchedule }> = ({ schedule }) => {
  const { t } = useTranslation();

  const daysOfWeek = [t("Mo"), t("Di"), t("Mi"), t("Do"), t("Fr"), t("Sa"), t("So")];

  const groupedSchedule = schedule.reduce(
    (acc, day, index) => {
      const key =
        day.length > 0
          ? day.map((range) => `${formatTime(range.start)} - ${formatTime(range.end)}`).join(", ")
          : t("Geschlossen");

      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key]?.push(index);
      return acc;
    },
    {} as Record<string, number[]>,
  );

  return (
    <div className="flex flex-col gap-1">
      {Object.entries(groupedSchedule).map(([times, days], index) => (
        <div key={index} className="grid grid-cols-[1fr,2fr] gap-3">
          <div>
            {days.length > 1
              ? `${daysOfWeek[days[0] ?? 0]} - ${daysOfWeek[days[days.length - 1] ?? 0]}`
              : daysOfWeek[days[0] ?? 0]}
          </div>
          <div className="pb-1 leading-tight">
            {times.split(", ").map((time) => (
              <div key={time}>{time}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
